import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100 d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "col-9 w-100 p-0" }
const _hoisted_3 = { class: "col-3 w-100 p-0" }
const _hoisted_4 = { class: "d-flex justify-content-around" }

import { coreApi } from "@/conection";
import { AlertModule } from "@/store/modules/Alert";
import { TicketModule } from "@/store/modules/Ticket";
import { ref } from "vue";

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    ticketId: null,
    client: null
  },
  emits: ["showIdentificationAdd"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
	ticketId?: string;
	client?: string;
}



// Data
const regex = /^[a-z0-9]{3,}$/i;

const identification = ref("");



function onSubmit() {
	identification.value = identification.value.trim();
	if (!regex.test(identification.value)) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Debe ingresar el identificador, sin caracteres especiales (solo números y letras). Mínimo tres caracteres",
			type: "error",
		});
		return;
	}

	const payload = {
		ticketID: props.ticketId ?? TicketModule.currentRoomID,
		client: props.client ?? TicketModule.currentTicket?.client[0]._id,
		identification: identification.value,
	};

	coreApi
		.post("/api/client/add-identification", payload)
		.then(response => {
			emits("showIdentificationAdd", {
				coincidences: response.data.coincidences,
				identifier: identification.value,
			});
		})
		.catch(e => {
			console.log(e, "ERROR");
		});
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        name: "identificator",
        class: "pl-3 pr-2",
        placeholder: "Identificador",
        modelValue: identification.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((identification).value = $event)),
        size: "small",
        "validate-event": false,
        alternative: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_tooltip, {
          content: "Guardar",
          placement: "top",
          class: "pr-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "fa fa-save fa-xs color-regular save-button",
              onClick: onSubmit
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tooltip, {
          content: "Cancelar",
          placement: "bottom",
          class: "text-right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: "fa fa-window-close fa-xs color-regular x-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('showIdentificationAdd')))
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})